import React from "react";

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="https://appegic.com/" target="_blank" rel="noreferrer">
            Appegic
          </a>{" "}
          2023
        </p>
      </div>
    </div>
  );
};

export default Footer;
